export default {
    isAdmin: state => state.user.isAdmin,
    pageType: (state) => (state.pageType !== null) ? true : false
}